import React from "react";
import { useParams } from "react-router-dom";
import { useEventContext } from "../../context/EventContext";
import { useLocaleContext } from "../../context/LocaleContext";
import { usePollsContext } from "../../context/PollsContext";
import { useQuizContext } from "../../context/QuizContext";
import { ModalContextProvider } from "../../context/ModalContext";
import PopUp from "../../components/PopUp";
import { PollsContent } from "../../components/Polls";
import QuizContent from "../../components/Quiz/QuizContent";
import Theme from "../EventPage/Theme";
import { Quizzes } from "../../components/Quiz";
import EventNotificationModal from "../../components/EventNotificationModal";

export default ({ type }) => {
    const { pollID, notificationID, quizID, pollIndex } = useParams();
    const { eventKey } = useEventContext();
    const $locale = useLocaleContext();
    const { allPolls } = usePollsContext();
    const { quizzes } = useQuizContext();

    const poll = (allPolls || []).find(({ id }) => String(id) === String(pollID));
    const quiz = (quizzes || []).find(({ id }) => String(id) === String(quizID));

    const isPoll = true
    const isEmptyTitle = !isPoll && poll && poll.private && 'result' !== poll.status;

    const Poll = () => (<PopUp
        title={!isEmptyTitle ? $locale.get(`polls.${isPoll ? 'title' : 'resultTitle'}`) : undefined}
        isOpen={poll}
    >
        <PollsContent
            eventKey={eventKey}
            preview
            isPoll={isPoll}
            poll={poll}
        />
    </PopUp>)

    const Quiz = () => pollIndex === 'preview' ?
        <Quizzes quizzes={[quiz]} preview /> :
        <PopUp
            isOpen={quiz}
            title={<div className="quiz-modal-title">{$locale.getProperty(quiz, "title")}</div>}
        >
            <QuizContent isShowHeader={false} quiz={quiz} preview previewPollIndex={pollIndex} authorizationCheck={() => { }} />
        </PopUp>

    const activity = {
        poll: poll && <Poll />,
        quiz: quiz && <Quiz />,
        notification: <EventNotificationModal preview={notificationID}/>
    }

    return <>
        <Theme />
        <ModalContextProvider>{activity[type]}</ModalContextProvider>
    </>
}